import { creatorbase } from '@round/api';
import { CreatorAccount } from '../CreatorAccountsTable/helpers';

type ExistingLine = creatorbase.ClassifiedLine & {
    platform: creatorbase.CreatorBulkUploadItemPlatform;
    handle: string;
    client_influencer_id: string;
    client_influencer_account_id: number;
};

// Classify only parses TikTok and Instagram urls, and always pairs an existing line with the account it
// matched, so a line missing any of that has no account to show.
const isExistingLine = (line: creatorbase.ClassifiedLine): line is ExistingLine =>
    (line.platform === 'tiktok' || line.platform === 'instagram') &&
    !!line.handle &&
    !!line.client_influencer_id &&
    line.client_influencer_account_id !== null;

/** The accounts the existing lines matched, one per line, keyed by the line it came from. */
export const toExistingCreatorAccounts = (lines: creatorbase.ClassifiedLine[]): CreatorAccount[] =>
    lines.filter(isExistingLine).map((line) => ({
        key: line.line,
        platform: line.platform,
        handle: line.handle,
        client_influencer_id: line.client_influencer_id,
        client_influencer_account_id: line.client_influencer_account_id,
    }));
